import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Env from 'lib/Env';
import { reportLogOut } from 'a/actions/searchlightActions';
import StandardFullPageErrorMessage from './StandardFullPageErrorMessage';
import { ERROR_STRINGS } from './constants';
import { logErrorToSearchlight, setIsShowingErrorScreen } from './actions';

if (Env.isDevEnv) {
  // Extend existing or create new AQUA_GLOBALS.QA namespace and add test functions
  AQUA_GLOBALS.QA = {
    ...AQUA_GLOBALS.QA,
    breakResourceFetching: () => {
      Env.GAME_CONTENT_URL += '/broke';
    },
    breakSearchlightApi: () => {
      Env.SEARCHLIGHT_SCHEMA_VERSION = '666.666';
    },
    breakProgressScreen: () => {
      Env.BREAK_PROGRESS_SCREEN = true;
    },
  };
}

export class GlobalErrorHandlerComponent extends Component {
  state = {
    hasError: false,
  };

  hasLoggedFirstError = false;

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (!this.hasLoggedFirstError) {
      this.props.setIsShowingErrorScreen();
      this.props.logErrorToSearchlight(error, info);
      this.hasLoggedFirstError = true;
    }
  }

  onErrorPageRetry = () => {
    if (this.props.forceLogout) {
      this.props.reportLogOut('errorPage');
    } else {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      if (this.props.secondaryText === ERROR_STRINGS.checkYourInternetConnection) {
        return (
          <StandardFullPageErrorMessage
            header={this.props.titleText}
            message={this.props.secondaryText}
            buttonTitle="Retry"
          />
        );
      }
      return (
        <StandardFullPageErrorMessage
          header={this.props.titleText}
          message={this.props.secondaryText}
          customCallback={this.onErrorPageRetry}
        />
      );
    }
    return this.props.children;
  }
}
GlobalErrorHandlerComponent.propTypes = {
  children: PropTypes.any,

  // ---- Redux reducer props ----
  titleText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string.isRequired,
  showHomeButton: PropTypes.bool.isRequired,
  showGamesButton: PropTypes.bool.isRequired,
  forceLogout: PropTypes.bool.isRequired,
  // ---- Redux action functions----
  reportLogOut: PropTypes.func.isRequired,
  logErrorToSearchlight: PropTypes.func.isRequired,
  setIsShowingErrorScreen: PropTypes.func.isRequired,
};
GlobalErrorHandlerComponent.defaultProps = { children: null };

function mapStateToProps(state) {
  return {
    titleText: state.globalErrorReducer.titleText,
    secondaryText: state.globalErrorReducer.secondaryText,
    showHomeButton: state.globalErrorReducer.showHomeButton,
    showGamesButton: state.globalErrorReducer.showGamesButton,
    forceLogout: state.globalErrorReducer.forceLogout,
  };
}

const mapDispatchToProps = {
  reportLogOut,
  logErrorToSearchlight,
  setIsShowingErrorScreen,
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalErrorHandlerComponent);
